import React from 'react';
import {StyleSheet} from 'react-native';
// https://github.com/iamacup/react-native-markdown-display/issues/158
// -> https://github.com/iamacup/react-native-markdown-display/issues/158#issuecomment-1453731664
//   -> https://www.npmjs.com/package/@ronradtke/react-native-markdown-display
import RNMarkdownDisplay, {
  MarkdownProps as RNMarkdownDisplayProps,
} from '@ronradtke/react-native-markdown-display';

import {textBodyStyles, textCaptionStyles, TextVariant} from './Text';

type MarkdownProps = RNMarkdownDisplayProps & {
  variant?: TextVariant;
  style?: StyleSheet.NamedStyles<any>;
};

const Markdown = ({
  children,
  variant = 'body',
  style = {},
  ...rest
}: MarkdownProps) => {
  if (!children) return null;

  const selectedStyles = variant === 'caption' ? captionStyles : bodyStyles;
  const styles = {...selectedStyles, ...style};

  return (
    <RNMarkdownDisplay {...rest} style={styles}>
      {children}
    </RNMarkdownDisplay>
  );
};

const captionStyles = StyleSheet.create({
  body: textCaptionStyles,
  paragraph: {
    marginTop: 0,
    marginBottom: 0,
  },
});

const bodyStyles = StyleSheet.create({
  body: textBodyStyles,
});

export default Markdown;
